import { DishItemDisplayType, type LocalDishType } from "@jidlomat/terminal-core/types/mainTypes";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { PriceWrapper } from "../../global/components/PriceWrapper";

type DishTypeInfoRowProps = {
	dishType: LocalDishType;
	type: DishItemDisplayType;
	pieces?: number;
};

export function InfoRow({ dishType, type, pieces }: DishTypeInfoRowProps) {
	const { t } = useTranslation();
	const { weight, price } = dishType;

	return (
		<StyledDishTypeInfoRow>
			{price && <PriceWrapper price={price} type={type} />}
			{type === DishItemDisplayType.LIST && weight ? (
				<QuantityWeightText>
					{Intl.NumberFormat("cs-CZ", {
						style: "unit",
						unit: "gram",
					}).format(Number.parseInt(weight, 10))}
				</QuantityWeightText>
			) : (
				<QuantityWeightText>{t("common.pcs", { count: pieces })}</QuantityWeightText>
			)}
		</StyledDishTypeInfoRow>
	);
}

const StyledDishTypeInfoRow = styled(Box)(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	justifyContent: "flex-start",
	alignItems: "baseline",
	width: "100%",
	marginTop: theme.spacing(1),
}));

const QuantityWeightText = styled(Typography)(({ theme }) => ({
	fontWeight: 500,
	fontSize: "1.5rem",
	lineHeight: "1.75rem",
	color: theme.palette.common.white,
	marginLeft: "auto",
}));
